import { Box, Typography } from '@mui/material'
import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { MenuFormWidget } from '@/widgets/menu-form-widget'
import { useMenuFormStore } from '@/widgets/menu-form-widget/store'

export const Route = createFileRoute('/_auth/canteen/menu-settings/catalog-menu/create')({
  validateSearch: (search: Record<string, unknown>) => ({
    draftId: typeof search.draftId === 'string' ? search.draftId : undefined,
  }),
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()
  const { draftId } = Route.useSearch()
  const clearForm = useMenuFormStore((state) => state.clearForm)

  // Clear form when entering create page (only for new menus, not draft editing)
  useEffect(() => {
    if (!draftId) {
      clearForm()
    }
  }, [clearForm, draftId])

  const title = draftId ? t('Редактирование черновика меню') : t('Создание меню')

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px', height: '100%' }}>
      <Typography variant="h1">{title}</Typography>
      <MenuFormWidget draftId={draftId} />
    </Box>
  )
}
